<template>
  <div>
    <div class="ln-login">
      <Form ref="form">
        <Field v-model="username" placeholder="账号" :rules="[{ required: true, message: '请填写账号' }]">
          <i slot="left-icon" class="iconfont iconuser"></i>
        </Field>
        <Password v-model="password" :passText="ispassword"></Password>
        <div class="bottom">
          <Row class="login-row">
            <Button class="login-btn" block type="info" @click="login"> 进入游戏 </Button>
          </Row>

          <Row class="login-row" gutter="10">
            <Col span="12" v-if="oldBtn"
              ><Button block type="info" native-type="button" @click="guestLogin">快速注册</Button>
            </Col>
            <Col span="12" v-if="!oldBtn"
              ><Button block type="info" native-type="button" @click="guestStart">账号登录</Button>
            </Col>
            <!-- <Col span="12"><Button block
                    type="info"
                    @click="register">手机注册</Button></Col> -->
            <Col span="12"><Button block type="info" @click="openAccountRegist()">账号注册</Button></Col>
          </Row>

          <Row class="login-row link-wrap" style="justify-content: space-between">
            <!-- <span class="link" @click="changeComponent('PhoneLogin')">手机登录</span> -->
            <!-- <span class="link"
                  style="flex:1"
                  @click="openAccountRegist()">账号注册</span> -->
            <span style="flex: 1" v-if="is_vertify != 0"></span>
            <span class="link" style="flex: 1" v-if="is_vertify == 0" @click="openDelAcc()">删除账号</span>
            <span class="link" @click="forgetPass">忘记密码?</span>
          </Row>

          <Row class="login-row link-wrap" style="justify-content: center">
            <AgreeRegister v-model="agree"></AgreeRegister>
            <span style="font-size: 13px; margin-top: 7px; margin-left: 5px">同意游戏</span
            ><span
              class="link"
              style="vertical-align: center; margin-left: 0px; margin-top: 7px"
              @click="openProtocal(1)"
              >《用户协议》</span
            >
            <span style="font-size: 13px; margin-top: 7px">及</span>
            <span style="font-size: 13px; margin-top: 7px" @click="openProtocal(2)" class="link">《隐私协议》</span>
          </Row>
        </div>
      </Form>
      <!-- <van-icon style="position:absolute;right:0;top:0;right:10px;top:10px;" name="cross" @click="closeWindow" /> -->
    </div>
    <!-- 用户协议弹窗 -->
    <div v-if="isProto" class="lngame_proto">
      <div class="lngame_proto_con" style="height: 100%; width: 100%">
        <div style="height: 90%; padding: 15px">
          <iframe :src="userProtocol" style="width: 100%; height: 100%" frameborder="0"></iframe>
        </div>
      </div>
      <van-icon
        style="position: absolute; right: 0; top: 0; right: 10px; top: 10px; z-index: 3000"
        name="cross"
        @click="closeProto"
      />
    </div>

    <!-- 删除账号 -->
    <div v-if="isDelAcc" class="lngame_proto">
      <DelAccount @backClick="backClick" />
    </div>
  </div>
</template>

<script>
import cookies from '@/cookies';
import { Form, Field, Button, Col, Row, Dialog } from 'vant';
import { commonMixin } from '@/mixin';
import Password from '@/components/Password';
import AgreeRegister from '@/components/AgreeRegister';
import DelAccount from '@/components/DelAccount';
// import AccountRegist from '@/components/AccountRegist.vue';
import { mapState } from 'vuex';
// 不能直接在这里解构，后续需检查 ！！
import server from '@/server';
import channelServer from '@/server/channelServer';
import { getUrlParams } from '@/utils';
import AES from '@/AES';
export default {
  name: 'ln-login',
  mixins: [commonMixin],
  components: { Form, Field, Button, Col, AgreeRegister, Row, DelAccount, Password },
  data() {
    return {
      username: '',
      password: '',
      agree: Boolean(localStorage.getItem('agreeProt')) || false,
      isProto: false,
      ispassword: 'password',
      oldBtn: true,
      userProtocol: 'https://apisdk.lnqwe.com/uc/user/user_protocol?ln=1',
      isDelAcc: false,
      is_vertify: localStorage.getItem('ln_is_vertify'),
      clickTimer: null,
      clickGuestTimer: null,
    };
  },
  computed: {
    ...mapState(['user', 'protocal_url', 'guestInfo', 'is_agree', 'changeBind', 'button_interval']),
  },
  created() {
    // 如果登录过默认取storage自动填充帐密
    if (localStorage.getItem('lnUserAccount') || cookies.getItem('lnUserPass')) {
      console.log(localStorage.getItem('lnUserAccount'));
      this.username = localStorage.getItem('lnUserAccount') || '';
      this.password = localStorage.getItem('lnUserPass') || '';
    }
    this.$store.commit('SET_COMPNAME', '账号登录');
    console.log(this.$store.state.changeBind);
    if (this.$store.state.changeBind) {
      this.username = '';
      this.password = '';
    }
  },
  watch: {
    changeBind(val) {
      if (val) {
        this.username = '';
        this.password = '';
      }
    },
  },
  mounted() {
    const cookieUserName = cookies.getItem('ln_h5sdk_user_name');
    const storageUser = localStorage.getItem('lnUserAccount') || localStorage.getItem('userAccountguest');
    if (cookieUserName) {
      // this.username = cookieUserName;
    }
  },
  methods: {
    // 进入游戏
    login() {
      if (!this.agree) {
        Dialog.alert({ message: '请先同意用户隐私协议' });
        return;
      }
      this.$store.commit('SET_USER_INFO', { name: this.username, pwd: this.password });
      if (this.clickTimer) clearTimeout(this.clickTimer);
      this.clickTimer = setTimeout(() => {
        this.$store.commit('SET_LOGINTYPE', 1);
        this.formCheck('form').then(() => {
          if (
            server.getToken() &&
            this.password == localStorage.getItem('lnUserPass') &&
            this.username == localStorage.getItem('lnUserAccount') &&
            !this.$store.state.forgetPwd
          ) {
            server.autoLogin();
          } else {
            let IV = AES.generatekey();
            const params = {
              uname: this.username,
              upass: IV + AES.encrypt(encodeURI(this.password), 'LN_85%@A6f*&0d!k', IV),
              decrypt_pwd: 1,
            };
            cookies.setItem('userAccount', this.username);
            cookies.setItem('userPass', this.password);
            // localStorage.setItem('lnUserAccount', this.username);
            // localStorage.setItem('lnUserPass', this.password);
            server.login(params);
          }
        });
      }, this.button_interval);
    },
    // 打开删除账号
    openDelAcc() {
      this.isDelAcc = true;
    },
    backClick(e) {
      this.isDelAcc = e;
    },
    guestStart() {
      if (!this.agree) {
        Dialog.alert({ message: '请先同意用户隐私协议' });
        return;
      }
      this.$store.commit('SET_COMPNAME', '账号登录');
      this.oldBtn = true;
      this.username = '';
      this.password = '';
      // this.$store.commit('CLOSE');
    },
    register() {
      this.changeComponent('PhoneRegister');
    },
    forgetPass() {
      this.changeComponent('ForgetPassword');
      this.$store.commit('SAVECURRCOMP', 'Login');
    },
    closeWindow() {
      this.$store.commit('CLOSE');
    },
    guestLogin() {
      if (!this.agree) {
        Dialog.alert({ message: '请先同意用户隐私协议' });
        return;
      }
      if (this.clickGuestTimer) clearTimeout(this.clickGuestTimer);
      this.clickGuestTimer = setTimeout(() => {
        this.oldBtn = false;
        cookies.setItem('userAccount', this.username);
        cookies.setItem('userPass', this.password);
        this.$store.commit('SET_COMPNAME', '快速注册');
        this.$store.commit('SET_LOGINTYPE', 2);
        channelServer.guestLogin().then((data) => {
          this.username = localStorage.getItem('lnUserAccount') || this.user.account;
          this.password = localStorage.getItem('lnUserPass') || this.user.passwd;
          localStorage.setItem('lnUserAccount', data.account);
          // let IV = data.passwd.slice(0, 16);
          // let data_pwd = data.passwd.slice(16, data.passwd.length);
          // console.log(AES.decrypt(data_pwd, 'LN_85%@A6f*&0d!k', IV))
          // localStorage.setItem('lnUserPass', AES.decrypt(data_pwd, 'LN_85%@A6f*&0d!k', IV));
          this.$store.commit('SET_USER_INFO', { name: data.account, pwd: data.passwd });
          localStorage.setItem('lnUserPass', '******');
          server.autoLogin();
        });
      }, this.button_interval);
    },
    // 打开用户协议
    openProtocal(type) {
      this.isProto = true;
      const host = window.location.host;
      const noLnDomain = `https://${host}`;
      const prodBaseUrl = location.host === 'apisdk.lnqwe.com' ? 'https://apisdk.lnqwe.com' : noLnDomain;
      this.userProtocol =
        type == 1
          ? `${prodBaseUrl}/uc/user/user_protocol?appid=${getUrlParams('appid')}`
          : `${prodBaseUrl}/uc/user/privacy_protocol?appid=${getUrlParams('appid')}`;
    },
    closeProto() {
      this.isProto = false;
    },
    openAccountRegist() {
      this.changeComponent('AccountRegist');
    },
  },
};
</script>
<style lang="scss">
/* @import url() */
.ln-login {
}

.lngame_proto {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 2002;
  background: rgba(0, 0, 0, 0.4);
}

.lngame_proto_con {
  width: 100%;
  height: 350px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
